import { getData, updateFromData, postFormData, postData } from './api.helpers'
import apiUrl from './api.url'

export const logoutUser = () => postData('login/logout', {})

// const buildUrlWithParams = (baseUrl: string, params: any) => {
//   return `${baseUrl}${parseQueryParams(params)}`
// }
export const getImpersonate = (id: string) => {
  return getData(`${apiUrl.EMPLOYEE_LIST_URL}permissions/${id}/`)
}

export const getCountries = () => getData(apiUrl.COUNTRIES)

export const updateAdminPassword = (employee: string, data: string) => {
  return updateFromData(
    `${apiUrl.ADMIN_USER}/${employee}/change_password`,
    data
  )
}

export const updateAssessorPassword = (id: string, data: string) => {
  return updateFromData(
    `${apiUrl.ASSESSOR_LIST_URL}/${id}/change_password`,
    data
  )
}

export const fileUpload = (id: string, input: any) => {
  return postFormData(`job/${id}/upload-zip`, input)
}

export const deleteZipDocument = (id?: string) => {
  return postFormData(`job/${id}/remove-zip`, {})
}
